/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CompanyMappingResponseDto } from '../models/PagedResultDto_CompanyMappingResponseDto';
import type { Wealthlane_CustomerService_AppServices_CustomerSuccess_CurrentSwitchAccessResult } from '../models/Wealthlane_CustomerService_AppServices_CustomerSuccess_CurrentSwitchAccessResult';
import type { Wealthlane_CustomerService_AppServices_CustomerSuccess_ServiceCompanyResponseDto } from '../models/Wealthlane_CustomerService_AppServices_CustomerSuccess_ServiceCompanyResponseDto';
import type { Wealthlane_CustomerService_Dtos_CustomerSuccess_ServiceCompanySwitchResponseDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerSuccess_ServiceCompanySwitchResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomerSuccessService {

    /**
     * @returns Wealthlane_CustomerService_AppServices_CustomerSuccess_ServiceCompanyResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessCompanies(): CancelablePromise<Array<Wealthlane_CustomerService_AppServices_CustomerSuccess_ServiceCompanyResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/companies',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_AppServices_CustomerSuccess_CurrentSwitchAccessResult OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessAccessStatus(): CancelablePromise<Wealthlane_CustomerService_AppServices_CustomerSuccess_CurrentSwitchAccessResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/access-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param destinationCompanyId
     * @param tenantId
     * @returns Wealthlane_CustomerService_Dtos_CustomerSuccess_ServiceCompanySwitchResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessSwitch(
        destinationCompanyId: string,
        tenantId?: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerSuccess_ServiceCompanySwitchResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/{destinationCompanyId}/switch',
            path: {
                'destinationCompanyId': destinationCompanyId,
            },
            query: {
                'tenantId': tenantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_CompanyMappingResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessAllowedCompanyMappings(
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_CompanyMappingResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/allowed-company-mappings',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
